import { useNavigate as useRouterNavigate } from 'react-router-dom'

const useNavigate = () => {
  const navigate = useRouterNavigate()
  return (to, opts) =>
    navigate(to, {
      ...opts,
      state: {
        ...opts?.state,
        canGoBack: true
      }
    })
}
export default useNavigate
